<template>
  <div id="publishing-editorial-board-add">
    <ipub-model
      :title="params.id ? 'Edit Editorial Board' : 'Add Editorial Board'"
      width="1100px"
      :visable="isVisable"
      @confirm="confirm"
      @cancel="cancel"
    >
      <ipub-form ref="editorial-board-add-form" :model="params" :rules="rules">
        <ipub-row>
          <ipub-col :span="9.5">
            <ipub-row :gutter="20">
              <ipub-col :span="3">
                <ipub-form-item prop="titleCode" label="Title">
                  <ipub-select
                    v-model="params.titleCode"
                    placeholder="Select title"
                  >
                    <ipub-select-option
                      v-for="value in titleList"
                      v-show="value.enabled"
                      :key="value.id"
                      :value="value.code"
                    >
                      {{ value.name }}
                    </ipub-select-option>
                  </ipub-select>
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="3">
                <ipub-form-item prop="firstName" label="First Name">
                  <ipub-input
                    placeholder="Select First Name"
                    v-model.trim="params.firstName"
                  />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="3">
                <ipub-form-item prop="lastName" label="Last Name">
                  <ipub-input
                    placeholder="Enter last name"
                    v-model.trim="params.lastName"
                  />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="3">
                <ipub-form-item prop="sort" label="Hierarchy">
                  <ipub-input
                    placeholder="Enter hierarchy"
                    number
                    v-model="params.sort"
                  />
                </ipub-form-item>
              </ipub-col>
            </ipub-row>
            <ipub-row :gutter="20">
              <ipub-col :span="4">
                <ipub-form-item prop="email" label="Email">
                  <ipub-input
                    placeholder="Enter frequency used public email"
                    :disabled="apply"
                    v-model.trim="params.email"
                  />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="4">
                <ipub-form-item prop="identityCode" label="Identity">
                  <ipub-select
                    v-model="params.identityCode"
                    placeholder="Select identity"
                  >
                    <ipub-select-option
                      v-for="value in editorialBoardList"
                      :key="value.id"
                      v-show="value.enabled"
                      :value="value.code"
                    >
                      {{ value.name }}
                    </ipub-select-option>
                  </ipub-select>
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="4">
                <ipub-form-item prop="journalId" label="journal">
                  <ipub-select
                    v-model="params.journalId"
                    placeholder="Select Journal"
                    @change="checkJournal"
                    :disabled="inputData.journalId != ''"
                    :options="journalList"
                  />
                </ipub-form-item>
              </ipub-col>
            </ipub-row>
          </ipub-col>
          <ipub-col :span="2.5" class="relative">
            <ipub-form-item prop="icon">
              <div class="upload-content right-option">
                <div class="upload-content-img">
                  <ipub-upload-cropper
                    @change="
                      (e) => {
                        handleUpload('icon', e)
                      }
                    "
                    :canWidth="105"
                    :canHeight="130"
                    :scales="2"
                    :imgUrl="
                      params.icon
                        ? domain + '/' + params.icon
                        : domain + '/imageFile/icon.svg'
                    "
                  />
                </div>
              </div>
            </ipub-form-item>
          </ipub-col>
        </ipub-row>

        <ipub-row :gutter="20">
          <ipub-col :span="6">
            <ipub-form-item
              prop="rankId"
              label="Academic Rank / Scientific Rank"
            >
              <ipub-select
                v-model="params.rankId"
                search
                @search="getAcademic"
                placeholder="Select academic rank / scientific rank"
              >
                <ipub-select-option
                  v-for="value in academicList"
                  v-show="value.enabled"
                  :key="value.id"
                  :value="value.code"
                >
                  {{ value.name }}
                </ipub-select-option>
              </ipub-select>
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="6">
            <ipub-form-item prop="degreesIdList" label="Degree / Credential">
              <ipub-select
                placeholder="Select degree / credential "
                mode="multiple"
                :tree="true"
                search
                @blur="getDegrees('')"
                @search="getDegrees"
                v-model="params.degreesIdList"
              >
                <ipub-select-option
                  v-for="item in degreesList"
                  v-show="item.enabled"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.name
                  }}<template v-if="item.otherName"
                    >({{ item.otherName }})</template
                  ></ipub-select-option
                >
              </ipub-select>
            </ipub-form-item>
          </ipub-col>
        </ipub-row>

        <ipub-form-item prop="affiliation">
          <div slot="label" class="ipub-p2 fw-bd mar-b-10">
            Affiliations <font class="key-color">*</font
            ><a class="link-color mar-l-20" @click="addMore('affiliations')">
              <font>
                <ipub-icon type="iconAdd" />
                Add New Affiliation
              </font>
            </a>
          </div>
          <div
            v-for="(item, index) in params.affiliations"
            class="mar-b-10"
            :key="'params.affiliations' + index"
          >
            <ipub-input
              placeholder="Enter affiliation details"
              :suffixIcon="index === 0 ? '' : 'iconClose'"
              @blur="getMore('affiliation')"
              @iconClick="delMore('affiliations', index)"
              v-model.trim="params.affiliations[index]"
            />
          </div>

          <!-- <ipub-button type="primary"
                       icon="iconAdd"
                       @click="addMore('affiliations')"
                       style="width:240px"
                       plain>Add Affilications</ipub-button> -->
        </ipub-form-item>
        <ipub-row :gutter="20">
          <ipub-col :span="6">
            <ipub-form-item prop="countryCode" label="Country / Territory">
              <ipub-select
                v-model="params.countryCode"
                search
                @search="countrySearch"
                placeholder="Select academic rank / scientific rank"
              >
                <ipub-select-option
                  v-for="item in countryList"
                  :value="item.code"
                  :key="'countryList' + item.code"
                >
                  {{ item.name }}
                  <template v-if="item.otherName"
                    >({{ item.otherName }})</template
                  >
                </ipub-select-option>
              </ipub-select>
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="6">
            <ipub-form-item prop="city" label="City">
              <ipub-input placeholder="City" v-model.trim="params.city" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-row :gutter="20">
          <ipub-col :span="2">
            <ipub-form-item prop="hindex" label="H-index">
              <ipub-input
                placeholder="Enter H-index"
                number
                v-model="params.hindex"
              />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="10">
            <ipub-form-item prop="hindexUrl" label="H-index URL">
              <ipub-input
                placeholder="Enter H-index URL"
                v-model.trim="params.hindexUrl"
              />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-form-item prop="hindexed">
          <ipub-radio
            :checked="params.hindexed"
            @change="
              () => {
                params.hindexed = !params.hindexed
              }
            "
            label="Choose to show H-index"
          />
        </ipub-form-item>
        <ipub-form-item prop="interest" label="Interests">
          <!-- <ipub-editor :height="200"
                       v-model="params.interest" /> -->
          <ipub-textarea
            :autoSize="{ cols: '', rows: '5' }"
            placeholder="Enter Interests here"
            v-model="params.interest"
          />
        </ipub-form-item>
        <ipub-row :gutter="20">
          <ipub-col :span="4">
            <ipub-form-item prop="orcid">
              <div slot="label">
                <div class="ipub-p1 mar-b-10" slot="label">
                  <ipub-icon
                    class="ipub-p4"
                    style="font-size: 14px; color: #a6ce39"
                    type="iconORCID"
                  />
                  ORCID
                  <ipub-tooltip placement="right" type="dark">
                    <div slot="title">
                      Like 0000-0001-2345-6789 or 0000123455556789
                    </div>
                    <ipub-icon
                      class="ipub-p1"
                      style="font-size: 14px"
                      type="iconInfo"
                    />
                  </ipub-tooltip>
                </div>
              </div>
              <ipub-input
                placeholder="Encourage to input"
                v-model.trim="params.orcid"
              />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="4">
            <ipub-form-item prop="researchGate" label="ReasearchGate Account">
              <ipub-input
                placeholder="Enter ResearchGate account"
                v-model.trim="params.researchGate"
              />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="4">
            <ipub-form-item prop="website" label="Personal Homepage">
              <ipub-input
                placeholder="Enter personal homepage URL"
                v-model.trim="params.website"
              />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-form-item prop="reviewJournal">
          <div slot="label" class="ipub-p2 fw-bd mar-b-10">
            Reviewed Journal <font class="key-color">*</font
            ><a class="link-color mar-l-20" @click="addMore('reviewJournals')">
              <font>
                <ipub-icon type="iconAdd" />
                Add New Reviewed Journal
              </font>
            </a>
          </div>
          <div
            v-for="(item, index) in params.reviewJournals"
            class="mar-b-10"
            :key="'params.reviewJournals' + index"
          >
            <ipub-input
              placeholder="Enter reviewed journal’s full name"
              :suffixIcon="index === 0 ? '' : 'iconClose'"
              @blur="getMore('reviewJournal')"
              @iconClick="delMore('reviewJournals', index)"
              v-model.trim="params.reviewJournals[index]"
            />
          </div>
          <!-- <ipub-button type="primary"
                       icon="iconAdd"
                       @click="addMore('reviewJournals')"
                       style="width:240px"
                       plain>Add Reviewed Journal</ipub-button> -->
        </ipub-form-item>
        <ipub-form-item prop="cv">
          <div class="mar-b-10 ipub-p2 fw-bd relative" slot="label">
            CV
            <ipub-tooltip placement="right" type="dark" class="mar-l-10">
              <div slot="title">PDF</div>
              <ipub-icon type="iconInfo" />
            </ipub-tooltip>
          </div>
          <ipub-upload-input
            :file="params"
            _name="cvName"
            _path="cv"
            class="mar-b-20"
            :domain="domain"
            @delete="delFile('cv')"
            @change="
              (e) => {
                handleUpload('cv', e)
              }
            "
          />
        </ipub-form-item>
      </ipub-form>
      <div slot="footer" v-if="apply">
        <ipub-button
          plain
          type="primary"
          :style="{ minWidth: '150px' }"
          @click="confirm('UNHANDLED')"
          >Save</ipub-button
        >
        <ipub-button
          plain
          type="primary"
          :style="{ minWidth: '150px' }"
          @click="confirm('REFUSED')"
          >Reject</ipub-button
        >
        <ipub-button
          type="primary"
          :style="{ minWidth: '150px' }"
          @click="confirm('ACCEPTED')"
          >Agree</ipub-button
        >
      </div>
    </ipub-model>
    <!-- <AddRank :isVisable="showRank"
             @confirm="dialogConfirm"
             @cancel="dialogCancel" />
    <AddDegree :isVisable="showDegree"
               @confirm="dialogConfirm"
               @cancel="dialogCancel" /> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getUploadConfig } from '@/utils/upload'
import { eboard, eboardApply } from '@/api/eboard'
import { settingOption } from '@/api/setting'
import help from '@/utils/help'

// import AddRank from './addRank.dialog.vue'
// import AddDegree from './addDegree.dialog.vue'
import journal from '@/api/journal'
import operation from '@/api/operation'
import { settingCountry } from '@/api/setting'
import check from '@/utils/check'

export default {
  components: {
    // AddRank, AddDegree
  },
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default() {
        return {}
      },
    },
    sections: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      params: {
        hindexed: false,
        affiliations: [''],
        reviewJournals: [''],
        journalId: '',
      },
      personJournalIdList: [],
      journalList: [],
      // showRank: false,
      // showDegree: false,
      academicList: [],
      degreesList: [],
      titleList: [],
      editorialBoardList: [],
      countryList: [],
      apply: false,
      rules: {},
      isCropper: false,
      canWidth: 200,
      canHeight: 225,
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
      title: 'getTitle',
      editorialBoard: 'getEditorialBoard',
    }),
  },
  watch: {
    isVisable(val) {
      if (!val) {
        this.params = {
          hindexed: false,
          affiliations: [''],
          reviewJournals: [''],
          journalId: '',
          interest: '',
        }
      } else {
        this.getJournalList()
        this.countrySearch()
      }
    },
  },
  mounted() {
    this.getRules()
  },
  methods: {
    async getQuery(id, data) {
      this.apply = !!data.apply
      if (this.apply) {
        this.params = await eboardApply.query(id, data)
      } else {
        this.params = await eboard.query(id, data)
      }
      const { affiliation, reviewJournal, degreesList } = this.params
      this.$set(
        this.params,
        'affiliations',
        affiliation ? affiliation.split(';') : []
      )
      this.$set(
        this.params,
        'reviewJournals',
        reviewJournal ? reviewJournal.split(';') : []
      )
      this.$set(
        this.params,
        'degreesIdList',
        degreesList
          ? degreesList.map((item) => {
              return item.id
            })
          : []
      )
    },
    async getData() {
      const academicList = await settingOption.get({ type: 'ACADEMIC_RANK' })
      const degreesList = await settingOption.get({ type: 'DEGREE' })
      const titleList = await settingOption.get({ type: 'TITLE' })
      const editorialBoardList = await settingOption.get({
        type: 'EDITORIAL_BOARD_IDENTITY',
      })
      this.academicList = academicList
      this.degreesList = degreesList
      this.titleList = titleList
      this.editorialBoardList = editorialBoardList
    },
    async getJournalList() {
      this.journalList = await journal.userGet()
      this.params.journalId = this.inputData.journalId
        ? this.inputData.journalId
        : ''
      this.getData()
    },

    async getAcademic(keyword) {
      this.academicList = await settingOption.get({
        keyword,
        type: 'ACADEMIC_RANK',
      })
    },
    async getDegrees(keyword) {
      this.degreesList = await settingOption.get({ keyword, type: 'DEGREE' })
    },

    addMore(key) {
      this.params[key].push('')
    },
    delMore(key, index) {
      if (this.params[key].length === 1) {
        return
      }
      this.params[key].splice(index, 1)
    },
    getMore(key) {
      const arr = []
      this.params[key + 's'].forEach((item) => {
        if (item) {
          arr.push(item)
        }
      })
      this.params[key] = arr.join(';')
    },

    delFile(key) {
      this.params[key] = ''
      this.params[key + 'Name'] = ''
    },

    goToPage(val, name) {
      help.download(val, name)
    },

    async handleUpload(key, files) {
      const file = files[0]
      const imgFiles = ['icon']
      const pdfFiles = ['cv']
      const imgTypes = ['image/jpeg', 'image/png']
      const pdfTypes = ['application/pdf']
      let rightType = true
      if (imgFiles.includes(key)) {
        rightType = imgTypes.includes(file.type)
      } else if (pdfFiles.includes(key)) {
        rightType = pdfTypes.includes(file.type)
      }
      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType,
        })
        return false
      }
      const MS = 2
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB',
        })
        return false
      }
      const url = await getUploadConfig(
        file,
        `${this.publisherId}/journal/${
          this.inputData.journalId
        }/editorial-board/${key}/${help.guid()}`
      )

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail,
        })
        return false
      }

      this.$set(this.params, key + 'Name', file.name)
      this.$set(this.params, key, url)
    },
    cancelCopper() {
      this.isCropper = false
    },
    uploadCropper() {
      this.isCropper = true
    },
    async checkEmail() {
      if (this.params.id) {
        return
      }
      const data = await eboard.checkEmail(this.params.email, {
        journalId: this.inputData.journalId,
      })
      if (data && data.id) {
        delete data.id
        const { affiliation, reviewJournal, degreesList, personJournalIdList } =
          data
        data.affiliations = affiliation ? affiliation.split(';') : []
        data.reviewJournals = reviewJournal ? reviewJournal.split(';') : []
        data.degreesIdList = degreesList
          ? degreesList.map((item) => {
              return item.id
            })
          : []
        this.params = Object.assign(this.params, data)
        this.personJournalIdList = personJournalIdList
        return data
      }
    },
    checkOrcid(val) {
      const exg1 = /^(([0-9]{4,4})-){3,3}[0-9]{4,4}\b$/
      const exg2 = /^[0-9]{16,16}$/
      // console.log(val.match(exg1), '校验', val.match(exg2))
      if (!val) {
        return true
      }
      if (val.match(exg1) || val.match(exg2)) {
        return true
      } else {
        return false
      }
    },
    async confirm(handle) {
      const flag = this.$refs['editorial-board-add-form'].validate()
      if (flag) {
        // const data = Object.assign(this.params, {
        //   journalId: this.inputData.journalId,
        // })
        const data = this.params
        this.params.affiliation = this.params.affiliations.join(';')
        this.params.reviewJournal = this.params.reviewJournals.join(';')

        let res = ''
        if (handle) {
          data.handle = handle
          await eboardApply.accepted(this.params.id, Object.assign(data))
          this.$message.success({
            title: 'Success',
            content: `The Editoral Board has been ${
              handle === 'UNHANDLED' ? 'saved' : handle.toLowerCase()
            }!`,
          })
        } else {
          data.released = false
          if (this.params.id) {
            res = await eboard.edit(this.params.id, data)
          } else {
            res = await eboard.add(data)
            let journal = {}
            this.journalList.some((item) => {
              if (item.id === data.journalId) {
                journal = item
              }
            })
            await operation.add({
              authorityCode: 'WEBSITE.EDITOR_BOARD.CREATE_NEW',
              type: 'ADD',
              info: `Add Editorial Board:  ${data.email}`,
              detail: `【First Name】: ${data.firstName}<br/>
                      【Last Name】: ${data.lastName}<br/>
                      【Email 】: ${data.email}<br/>
                      【Identity】: ${
                        this.editorialBoard[data.identityCode]
                      }<br/>
                      【Journal】: ${journal.name} `,
            })
          }
          this.$message.success({
            title: 'Success',
            content: 'This Editorial Board has been saved!',
          })
        }
        this.$emit('confirm', res || data)
      }
    },
    cancel() {
      this.$emit('cancel')
    },

    checkJournal(val) {
      if (this.personJournalIdList.includes(val)) {
        this.$message.error({
          title: 'Error',
          content: `You are already being part of our editorial board, please do not submit repeatedly.`,
        })
      }
    },

    async countrySearch(val) {
      this.countryList = await settingCountry.getAll({
        keyword: val,
      })
    },

    getRules() {
      this.rules = {
        firstName: [
          {
            required: true,
            message: 'First Name' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        lastName: [
          {
            required: true,
            message: 'Last Name' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        journalId: [
          {
            required: true,
            message: 'Journal' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        email: [
          {
            required: true,
            message: 'Email' + this.LANGUAGE[this.language].noEmpty,
          },
          {
            type: 'email',
            message: this.LANGUAGE[this.language].enterCorrent + 'Email',
          },
          { fun: this.checkEmail },
        ],
        orcid: [
          {
            fun: check.orcid,
            message: `Encourage input ORCID`,
          },
        ],
        // titleCode: [
        //   {
        //     required: true,
        //     message: 'Title' + this.LANGUAGE[this.language].noEmpty
        //   }
        // ],
        // degreesIdList: [
        //   {
        //     required: true,
        //     message: 'Degree / Credential' + this.LANGUAGE[this.language].noEmpty
        //   }
        // ],
        identityCode: [
          {
            required: true,
            message: 'Identity' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        affiliation: [
          {
            required: true,
            message: 'Affiliations' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        interest: [
          {
            required: true,
            message: 'Interest' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        website: [
          {
            type: 'website',
            message: this.LANGUAGE[this.language].enterCorrent + 'Website',
          },
        ],
        hindexUrl: [
          {
            type: 'website',
            message: this.LANGUAGE[this.language].enterCorrent + 'H-index Url',
          },
        ],
        countryCode: [
          {
            required: true,
            message:
              'Country / Territory' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        city: [
          {
            max: 256,
            message: `City length must not be more than 256 digits`,
          },
        ],
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#publishing-editorial-board-add {
  .upload-content {
    height: 140px;
    width: 135px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    &-img {
      border-radius: 4px;
      height: 140px;
      width: 125px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
